import React from 'react';
import './Footer.css';
import logoSmall from '../../assets/images/logo-small.svg';
import arrowLink from '../../assets/images/arrow-link.svg';

const Footer: React.FC = () => {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="footer-section">
      <div className="footer-grid">
        {/* Row 1 */}
        <div className="separator" />
        <div className="separator" />
        <div className="separator" />
        <div className="separator" />
        <div className="row-content">
          <img src={logoSmall} alt="Heal" className="footer-logo" />
          <div className="footer-text"></div>
          <div className="footer-text footer-text-mobile-only">Heal</div>
          <div className="footer-text"></div>
        </div>

        {/* Row 2 */}
        <div className="separator" />
        <div className="separator" />
        <div className="separator" />
        <div className="separator" />
        <div className="row-content">
          <div className="footer-text">App</div>
          <a
            href={process.env.REACT_APP_APP_STORE_URL || 'https://apps.apple.com/app/heal'}
            target="_blank"
            rel="noopener noreferrer"
            className="footer-text"
          >
            IOS APP
          </a>
          <a
            href={process.env.REACT_APP_APP_STORE_URL || 'https://apps.apple.com/app/heal'}
            target="_blank"
            rel="noopener noreferrer"
            className="footer-text"
          >
            Heal is live
          </a>
          <div></div>
        </div>

        {/* Row 3 */}
        <div className="separator" />
        <div className="separator" />
        <div className="separator" />
        <div className="separator" />
        <div className="row-content">
          <div className="footer-text">Connect</div>
          <div className="footer-text-stack">
            <a href="https://www.instagram.com/healmusicapp" target="_blank" rel="noopener noreferrer" className="footer-text">Instagram</a>
            <a href="mailto:info@healmusicapp.com" className="footer-text">Contact</a>
          </div>
          <div className="footer-text-stack">
            <a href="https://www.instagram.com/healmusicapp" target="_blank" rel="noopener noreferrer" className="footer-text-with-arrow" aria-label="Instagram">
              <img src={arrowLink} alt="" className="footer-arrow" aria-hidden />
            </a>
            <a href="mailto:info@healmusicapp.com" className="footer-text-with-arrow" aria-label="Email Heal">
              <img src={arrowLink} alt="" className="footer-arrow" aria-hidden />
            </a>
          </div>
          <div></div>
        </div>

        {/* Row 4 */}
        <div className="separator" />
        <div className="separator" />
        <div className="separator" />
        <div className="separator" />
        <div className="row-content">
          <div></div>
          <div></div>
          <div></div>
          <div></div>
        </div>
      </div>
      <div className="footer-bottom">
        <div className="footer-links">
          <a href="/terms" className="footer-link">Terms and Conditions</a>
          <a href="/privacy" className="footer-link">Privacy</a>
          <a href="/app-privacy" className="footer-link">App privacy</a>
          <a href="/troubleshooting" className="footer-link">Troubleshooting</a>
        </div>
        <div className="footer-company-info">
          © {currentYear} Heal Music Ltd
        </div>
      </div>
    </footer>
  );
};

export default Footer; 